import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from 'ha/services/apiV2/types/User';
import { APIV2_URL } from './constants';

interface AvatarURLPayload {
  avatarUrl: string;
}

export default (makeCall: MakeCall) => (data: AvatarURLPayload) =>
  makeCall<User>('POST', `${APIV2_URL}/user/me/avatar-url`, {
    data,
  });
